<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12">
        <h1 class="text-center">Cargando datos de Pago...</h1>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
export default {
  name: "CircuitoPago",
  components: {
    CardIeaAppMain
  },
  mounted() {
    let idCircuito = this.$route.params.id;
    let secretKey = this.$route.params.idML;
    if (idCircuito && secretKey) {
      this.$API
        .get({
          url: "circuito/status-pago/" + secretKey,
          data: {}
        })
        .then(res => {
          if (res) {
            if (res.ML_Estado == "Exito: Pendiente Verificar") {
              setTimeout(() => {
                this.$router.replace({ name: "CircuitoInscripcion" });
              }, 2000);
            } else {
              this.$API
                .post({
                  url: "circuito/pago",
                  data: {
                    circuito_id: idCircuito,
                    preincrito_id: secretKey
                  }
                })
                .then(res2 => {
                  window.location.href = res2;
                  //setTimeout(() => {
                    //window.location.href = res2;
                    //   window.open(res, '_blank');
                  //}, 2000);
                });
            }
          }
        });
    }
  },
  data: () => ({}),
  methods: {}
};
</script>
